import type { MeDto } from '@ads/shared';
import { useQueryClient } from '@tanstack/react-query';
import { useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router';
import { TextField } from '../components/Field';
import * as Ic from '../components/icons';
import { useToggleTheme } from '../lib/prefs';
import { ApiError, api } from '../lib/api';
import { keys } from '../lib/queries';

export function Login() {
  const nav = useNavigate();
  const qc = useQueryClient();
  const toggleTheme = useToggleTheme();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    if (!email || !password) { setErr('Informe e-mail e senha.'); return; }
    setBusy(true); setErr(null);
    try {
      const me = await api<MeDto>('/auth/login', { method: 'POST', body: { email, password } });
      qc.setQueryData(keys.me, me);
      nav('/inicio', { replace: true });
    } catch (x) {
      setErr(x instanceof ApiError ? x.message : 'Não foi possível entrar agora.');
    } finally { setBusy(false); }
  };

  return (
    <div className="login">
      <button className="icon-btn login-theme" type="button" aria-label="Alternar tema" onClick={toggleTheme}><Ic.Sun /><Ic.Moon /></button>
      <form className="panel login-panel" onSubmit={submit}>
        <div className="corners" aria-hidden="true"><span className="tl" /><span className="tr" /><span className="br" /><span className="bl" /></div>
        <div className="lockup login-lockup"><span className="mark">ADS</span><span className="sub">Aion Design System</span></div>
        <h1><span className="ln"><i>Entrar</i></span></h1>
        <p className="lede">Estratégia, DNA e Studio — num só lugar.</p>
        <div className="stack" style={{ gap: 18 }}>
          <TextField id="email" label="E-mail" type="email" value={email} autoComplete="username" onChange={setEmail} />
          <TextField id="password" label="Senha" type="password" value={password} autoComplete="current-password" onChange={setPassword} />
        </div>
        {err && <p className="login-err" role="alert"><Ic.Warning />{err}</p>}
        <button className="btn-primary login-go" type="submit" disabled={busy}>
          {busy ? 'Entrando…' : 'Entrar'}<Ic.ArrowRight />
        </button>
      </form>
    </div>
  );
}
